import React, { useState, useEffect, forwardRef, ReactElement, useRef } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import api from "../components/api";
import { Link } from 'react-router-dom'
import toast from "react-hot-toast";
import Badge from 'react-bootstrap/Badge';

import EmissaoAnexos from "./EmissaoAnexos";
import EmissaoDocumentoUpload, { iTipoDocumentoPdf } from "./EmissaoDocumentoUpload";

import { useMutation, useQueryClient, useIsMutating } from '@tanstack/react-query'

import { useForm, Controller } from "react-hook-form";
import moment from 'moment'
//import CurrencyInput from '../components/CurrencyInput';
import { CurrencyInputBR } from '../components/CurrencyInputBR'
import TextInput from '../components/TextInput';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

import { ptBR } from "date-fns/locale/pt-BR";

import JoditEditorComponent from "../components/JoditEditorComponent";


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    razaoSocial: string,
    cnpj: string,


}

interface iMoedas {

    moeda_id: number,
    descricao: string,

}

interface iTomador {

    tomador_id: number,
    cnpj: string,
    cpf: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    tipoJuridico: string,
    outroDocumento: string,
    tomador: string,

}


interface iFavorecido {

    favorecido_id: number,
    cnpj: string,
    cpf: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    tipoJuridico: string,
    outroDocumento: string,
    favorecido: string,

}

interface iModalidades {

    modalidade_id: string,
    descricao: string,

}



const FormEmissao = (props: any) => {

    const savingToastId = useRef<string | null>(null);

    //const queryClient = useQueryClient()
    const isMutating = useIsMutating();


    const [totalAnexos, setTotalAnexos] = useState<number>(0)

    const [emissao_id, setEmissao_id] = useState<number | undefined>()

    const [pin, setPin] = useState<string>(props.pin ? props.pin : '')

    const [key, setKey] = useState<string | null>('dadosGerais');
    const [usuario_id_session, setUsuario_id_session] = useState<number | undefined>()
    const [cliente_id, setCliente_id] = useState<number>()
    const [clientes, setClientes] = useState<[]>([])

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')


    const [resultadoTomador, setResultadoTomador] = useState<React.ReactNode>()
    const [tomador_id, setTomador_id] = useState<number | undefined>()
    const [tomador, setTomador] = useState<string | undefined>('')
    const [colorTomador, setColorTomador] = useState<string>('#FFF')

    const [resultadoFavorecido, setResultadoFavorecido] = useState<React.ReactNode>()
    const [favorecido_id, setFavorecido_id] = useState<number | undefined>()
    const [favorecido, setFavorecido] = useState<string | undefined>('')
    const [colorFavorecido, setColorFavorecido] = useState<string>('#FFF')

    const [startDate, setDate] = useState(new Date());
    const [startDate2, setDate2] = useState(new Date());

    const [dias, setDias] = useState<number | undefined>()
    const [dataVencimento, setDataVencimento] = useState(new Date());

    const [moedas, setMoedas] = useState<iMoedas[]>([])
    const [moeda_id, setMoeda_id] = useState<number | undefined>()

    const [dataEmissao, setDataEmissao] = useState<string>('')
    const [dataInicio, setDataInicio] = useState<string>('')

    const [dataVencimentoIndeterminado, setDataVencimentoIndeterminado] = useState<string>('')

    const [valor, setValor] = useState<number>(0)
    //const [premio, setValorPremio] = useState<string | undefined>('')
    const [valorComissao, setValorComissao] = useState<number>(0)
    const [valorSpread, setValorSpread] = useState<number>(0)
    const [objeto, setObjeto] = useState<string>('')
    const [objetoEmissao, setObjetoEmissao] = useState<string>('')

    const [modalidadeTexto, setModalidadeTexto] = useState<string>('')
    const [taxa, setTaxa] = useState<number | undefined>()
    const [premio, setPremio] = useState<number>(0)
    const [pago, setPago] = useState<string>('')
    const [valorPago, setValorPago] = useState<number>(0)

    const [proposta, setProposta] = useState<boolean>(false)
    const [minuta, setMinuta] = useState<boolean>(false)
    const [garantia, setGarantia] = useState<boolean>(false)
    const [np, setNp] = useState<boolean>(false)

    const [linkProposta, setLinkProposta] = useState<string>('')
    const [linkMinuta, setLinkMinuta] = useState<string>('')
    const [linkGarantia, setLinkGarantia] = useState<string>('')
    const [linkNp, setLinkNp] = useState<string>('')

    const [linkCCg, setLinkCCg] = useState<string>('')
    const [ccg, setCCg] = useState<boolean>(false)

    const [showUpload, setShowUpload] = useState<boolean>(false)
    const [uploadTipo, setUploadTipo] = useState<iTipoDocumentoPdf>('G')

    const [juros, setJuros] = useState<string>('')

    const [multa, setMulta] = useState<string>()
    const [fiscal, setFiscal] = useState<string>()
    const [trabalhista, setTrabalhista] = useState<string>()

    const [textoMulta, setTextoMulta] = useState<string>('')
    const [textoFiscal, setTextoFiscal] = useState<string>('')
    const [textoTrabalhista, setTextoTrabalhista] = useState<string>('')

    const [sinistro, setSinistro] = useState<string>('')
    const [bloqueada, setBloqueada] = useState<string>('')
    //const [ad_usr, setAd_usr] = useState<string>('')

    //endosso
    const [endosso_emissao_id, setEndosso_emissao_id] = useState<number | undefined>()
    const [endosso, setEndosso] = useState<boolean>(false)

    const [endossoDescricao, setEndossoDescricao] = useState<string>('')
    //const [primeiroEndosso, setPrimeiroEndosso] = useState<boolean>(false)

    const [percentualComissao, setPercentualComissao] = useState<number | undefined>()

    const [modalidade_id, setModalidade_id] = useState<number | undefined>()
    const [modalidadeEmissao_id, setModalidadeEmissao_id] = useState<number | undefined>()
    const [modalidades, setModalidades] = useState<React.ReactNode>()

    const [tomadores, setTomadores] = useState<iTomador[]>([])
    const [tomadoresTabela, setTomadoresTabela] = useState<React.ReactNode>()
    const [totalTomadores, setTotalTomadores] = useState<number>(0)

    const [favorecidos, setFavorecidos] = useState<iFavorecido[]>([])
    const [favorecidosTabela, setFavorecidosTabela] = useState<React.ReactNode>()
    const [totalFavorecidos, setTotalFavorecidos] = useState<number>(0)
    const [observacoesCorretor, setObservacoesCorretor] = useState<string>('')
    const [observacoesSubscritor, setObservacoesSubscritor] = useState<string>('')

    const [open, setOpen] = useState<boolean>(false)
    const [acao, setAcao] = useState<string | undefined>('')
    const [titulo, setTitulo] = useState<string | undefined>('')
    const [frase, setFrase] = useState<string | undefined>('')

    //const [carregadoDaApi, setCarregadoDaApi] = useState<boolean>(false);
    const [emissaoCarregada, setEmissaoCarregada] = useState<number | null>(null);

    const [endossado, setEndossado] = useState<boolean>(false)


    const { control, handleSubmit } = useForm({
        defaultValues: {
            valor: 0,
            premio: "",
            valorComissao: "",
            valorSpread: "",
            valorPago: "",
            percentualComissao: "",
        },
    });

    const today = new Date()

    const selectDateHandler = (d: any) => {
        setDate(d)
    }

    const selectDateHandler2 = (d: any) => {
        setDate2(d)
    }

    const selectDateHandlerVencimento = (d: any) => {
        setDataVencimento(d)
    }

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            carregaClientes()
            setUsuario_id_session(dados.usuario_id)

            //setCliente_id(dados.cliente_id ? Number(dados.cliente_id) : undefined)


        }

    }, [dadosUsuarios])


    useEffect(() => {
        if (
          modalidade_id &&
          cliente_id &&
          modalidade_id !== modalidadeEmissao_id
        ) {
          carregaTextoModalidade();
        }
      }, [modalidade_id, cliente_id]);


      useEffect(() => {

        if (props.cliente_id) {

            setCliente_id(props.cliente_id)

        }

      }, [props.cliente_id])


    const carregaEmissao = (emissao_id: number) => {

        api.get(`emissaoListaUm/${emissao_id}`).then((result) => {

            var data = result.data[0]

            //console.log(data, 'aqui')

            setEmissao_id(emissao_id)

            setGarantia(data.garantia ? data.garantia : false)
            setMinuta(data.minuta ? data.minuta : false)
            setProposta(data.proposta ? data.proposta : false)
            setNp(data.np ? data.np : false)
            setCCg(data.ccg ? data.ccg : false)

            setPin(data.pin ? data.pin : '')

            setCliente_id(data.cliente_id)
            setDate(data.dataEmissao ? moment(data.dataEmissao, 'DD/MM/YYYY').toDate() : new Date())
            setDate2(data.dataInicio ? moment(data.dataInicio, 'DD/MM/YYYY').toDate() : new Date())
            setDataVencimento(data.dataVencimento ? moment(data.dataVencimento, 'DD/MM/YYYY').toDate() : new Date())
            setMoeda_id(data.moeda_id)
            setObjeto(data.objeto)
            setObjetoEmissao(data.objeto)
            setModalidade_id(data.modalidade_id)
            setModalidadeEmissao_id(data.modalidade_id)
            setModalidadeTexto(data.modalidadeTexto)

            setEmissaoCarregada(data.emissao_id);
            //setCarregadoDaApi(true);

            setMulta(data.multa != undefined ? data.multa == true ? '1' : '0' : '')
            setTrabalhista(data.trabalhista != undefined ? data.trabalhista == true ? '1' : '0' : '')
            setFiscal(data.fiscal != undefined ? data.fiscal == true ? '1' : '0' : '')

            if (data.textoMulta) { setTextoMulta(data.textoMulta) }
            if (data.textoFiscal) { setTextoFiscal(data.textoFiscal) }
            if (data.textoTrabalhista) { setTextoTrabalhista(data.textoTrabalhista) }

            setValor(data.valor ? data.valor : 0)
            setDias(data.dias ? data.dias : '')
            setDataVencimentoIndeterminado(data.dataVencimentoIndeterminado != undefined ? data.dataVencimentoIndeterminado == true ? '1' : '0' : '')

            setTomadores(data.tomadores)
            setFavorecidos(data.favorecidos)
            setValorComissao(data.valorComissao)
            setValorSpread(data.valorSpread)
            setPago(data.pago != undefined ? data.pago == true ? '1' : '0' : '')
            setPremio(data.premio)
            setTaxa(data.taxa)
            setValorPago(data.valorPago)
            setPercentualComissao(data.percentualComissao)
            setValorSpread(data.valorSpread)

            //setEndosso(data.endosso)
            //setEndosso_emissao_id(data.endosso_emissao_id)

            setEndossado(data.endossado ?? false)
            props.setEndossado(data.endossado ?? false)

            setEndossoDescricao(data.endosso == true ? 'Sim' : 'Não')

            setObservacoesCorretor(data.observacoesCorretor)
            setObservacoesSubscritor(data.observacoesSubscritor)

            const linkgarantik = `${process.env.REACT_APP_LINK_GARANTIK}/${data.cliente_id}/`


            if (data.minuta === 1 || data.minuta === true || data.minuta === 'True' || data.minuta === 'true') {
                setLinkMinuta(linkgarantik + 'MINUTA-' + data.pin + '.pdf')
            }

            if (data.proposta === 1 || data.proposta === true || data.proposta === 'True' || data.proposta === 'true') {
                setLinkProposta(linkgarantik + 'PROPOSTA-' + data.pin + '.pdf')
            }

            if (data.garantia === 1 || data.garantia === true || data.garantia === 'True' || data.garantia === 'true') {
                setLinkGarantia(linkgarantik + data.pin + '.pdf')
            }

            if (data.np === 1 || data.np === true || data.np === 'True' || data.np === 'true') {
                setLinkNp(linkgarantik + 'NP-' + data.pin + '.pdf')
            }

            if (data.ccg === 1 || data.ccg === true || data.ccg === 'True' || data.ccg === 'true') {
                setLinkCCg(linkgarantik + 'CCG-' + data.pin + '.pdf')
            }

        }).catch((err) => {
            console.log(err.response)
        })

    }




    useEffect(() => {

        if (emissao_id) {

            const linkgarantik = `${process.env.REACT_APP_LINK_GARANTIK}/${cliente_id}/`

            if (minuta === true) {
                setLinkMinuta(linkgarantik + 'MINUTA-' + pin + '.pdf')
            }

            if (proposta === true) {
                setLinkProposta(linkgarantik + 'PROPOSTA-' + pin + '.pdf')
            }

            if (garantia === true) {
                setLinkGarantia(linkgarantik + pin + '.pdf')
            }
        }

    }, [proposta, minuta, garantia])




    useEffect(() => {

        if (!props.emissao_id) {
            carregaClausulas()
        }

    }, [multa, trabalhista, fiscal])


    useEffect(() => {

        setEndosso_emissao_id(undefined)
        setEmissao_id(props.emissao_id)

    }, [props.emissao_id])


    const carregaMoedas = () => {

        api.get('moeda').then((result) => {

            setMoedas(result.data)

        }).catch((err) => {
            console.log(err.response)
        })

    }

    useEffect(() => {

        carregaMoedas()

    }, [])



    useEffect(() => {

        if (tomador_id) {

            setColorTomador('orange')

        } else {

            setColorTomador('white')

        }

    }, [tomador_id])



    useEffect(() => {

        if (favorecido_id) {

            setColorFavorecido('orange')

        } else {

            setColorFavorecido('white')

        }

    }, [favorecido_id])


    const adicionaTomador = (obj: any) => {

        //console.log(obj, 'obj')

        if (tomadores.filter(item => item.tomador_id === obj.tomador_id).length == 0) {

            setTomadores([...tomadores, obj])
            setResultadoTomador('')
            setTomador('')

        } else {

            toast.error('Tomador já inserido na lista!')

        }

    }


    const adicionaFavorecido = (obj: any) => {

        //console.log(obj, 'obj')

        if (favorecidos.filter(item => item.favorecido_id === obj.favorecido_id).length == 0) {

            setFavorecidos([...favorecidos, obj])
            setResultadoFavorecido('')
            setFavorecido('')

        } else {

            toast.error('Favorecido já inserido na lista!')

        }



    }

    const apagaTomador = (tomador_id: number) => {


        setTomadores(tomadores.filter(item => item.tomador_id !== tomador_id));

    }

    useEffect(() => {

        //console.log(tomadores)
        setTomadoresTabela(tomadores.map((rs) =>

            <tr>
                <td>
                    {rs.tomador}
                </td>
                <td style={{ cursor: 'pointer' }} onClick={() => apagaTomador(rs.tomador_id)}>
                    <span style={{ color: 'orange' }} >[Apagar]</span>
                </td>
            </tr>

        ))

        setTotalTomadores(tomadores.length)

    }, [tomadores])


    useEffect(() => {

        setFavorecidosTabela(favorecidos.map((rs) =>

            <tr>
                <td>
                    {rs.favorecido}
                </td>
                <td style={{ cursor: 'pointer' }} onClick={() => apagaFavorecido(rs.favorecido_id)}>
                    <span style={{ color: 'orange' }} >[Apagar]</span>
                </td>
            </tr>

        ))

        setTotalFavorecidos(favorecidos.length)

    }, [favorecidos])


    const apagaFavorecido = (favorecido_id: number) => {


        setFavorecidos(favorecidos.filter(item => item.favorecido_id !== favorecido_id));

    }

    useEffect(() => {

        setFavorecidosTabela(favorecidos.map((rs) =>

            <tr>
                <td>
                    {rs.favorecido}
                </td>
                <td style={{ cursor: 'pointer' }} onClick={() => apagaFavorecido(rs.favorecido_id)}>
                    <span style={{ color: 'orange' }} >[Apagar]</span>
                </td>
            </tr>

        ))

        setTotalTomadores(tomadores.length)

    }, [tomadores])


    useEffect(() => {

        if (tomador != '') {

            var dataPost = {

                tomador: tomador,
                cliente_id: cliente_id,

            }

            api.post('buscaTomador', dataPost).then((result) => {

                setResultadoTomador(result.data.map((rs: iTomador) =>

                    <Link to='#' onClick={() => adicionaTomador({

                        tomador_id: rs.tomador_id,
                        tomador: `${rs.tipoJuridico == 'J' ? `${rs.cnpj} - ${rs.razaoSocial}` : rs.tipoJuridico == 'F' ? `${rs.cpf} - ${rs.nome}` : `${rs.outroDocumento} - ${rs.nome}`}`,
                        cnpj: rs.cnpj,
                        tipoJuridico: rs.tipoJuridico,
                        cpf: rs.cpf,


                    })}><span style={{ color: 'purple' }}>[{rs.tipoJuridico == 'J' ? rs.cnpj : rs.tipoJuridico == 'F' ? rs.cpf : rs.outroDocumento}]</span> - {rs.tipoJuridico == 'J' ? rs.razaoSocial : rs.tipoJuridico == 'F' ? rs.nome : rs.outroDocumento}&nbsp;</Link>

                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }, [tomador])



    useEffect(() => {

        if (favorecido != '') {

            var dataPost = {

                descricao: favorecido,
                cliente_id: cliente_id,

            }

            api.post('favorecidoBusca', dataPost).then((result) => {

                setResultadoFavorecido(result.data.map((rs: iFavorecido) =>

                    <Link to='#' onClick={() => adicionaFavorecido({

                        favorecido_id: rs.favorecido_id,
                        favorecido: `${rs.tipoJuridico == 'J' ? `${rs.cnpj} - ${rs.razaoSocial}` : rs.tipoJuridico == 'F' ? `${rs.cpf} - ${rs.nome}` : `${rs.outroDocumento} - ${rs.nome}`}`,
                        cnpj: rs.cnpj,
                        tipoJuridico: rs.tipoJuridico,
                        cpf: rs.cpf,


                    })}><span style={{ color: 'purple' }}>[{rs.tipoJuridico == 'J' ? rs.cnpj : rs.tipoJuridico == 'F' ? rs.cpf : rs.outroDocumento}]</span> - {rs.tipoJuridico == 'J' ? rs.razaoSocial : rs.tipoJuridico == 'F' ? rs.nome : rs.outroDocumento}&nbsp;</Link>


                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }, [favorecido])


    const carregaClientes = () => {


        setClientes([])

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : undefined)
            

        }

    }

    const carregaModalidades = () => {

        var dataPost = {

            cliente_id: cliente_id,

        }

        api.post('modalidadeListaTodos', dataPost).then((result) => {

            setModalidades(result.data.map((rs: iModalidades) =>

                <option value={rs.modalidade_id}>{rs.descricao}</option>

            ))

        }).catch((err) => {

            console.log('erro no carregaModalidades: ', err.response)

        })

    }


    const carregaClausulas = () => {

        api.get(`listaClausulas/${cliente_id}`).then((result) => {

            setTextoMulta(result.data[0].textoMulta)
            setTextoFiscal(result.data[0].textoFiscal)
            setTextoTrabalhista(result.data[0].textoTrabalhista)

        }).catch((err) => {
            console.log(err.response)
        })

    }

    useEffect(() => {

        if (cliente_id) {

            carregaModalidades()

        }

    }, [cliente_id])

    const calculaDataVigencia = () => {
        if (startDate2 && dias) {
            const novaData = moment(startDate2).add(dias, 'days').toDate();
            setDataVencimento(novaData);
            return novaData;
        }

        return null;
    };

    const calculaDiasDeVigencia = () => {
        if (startDate2 && dataVencimento) {
            const inicio = moment(startDate2).startOf('day');
            const fim = moment(dataVencimento).startOf('day');

            const diferencaDias = fim.diff(inicio, 'days');

            setDias(diferencaDias);
            return diferencaDias;
        }

        return null;
    };


    const geraEndosso = () => {

        setEndosso(true);
        setEndosso_emissao_id(emissao_id);

        //setPrimeiroEndosso(true);


        //validaSalvar();


        if (tomadores.length == 0) {

            toast.error('Informe o tomador!')
            return false

        }

        if (favorecidos.length == 0) {

            toast.error('Informe o favorecido!')
            return false
        }

        setTitulo('Confirmação')
        setFrase('Confirma o endosso?')
        setAcao('salvar')
        setOpen(true)

    };

    const validaApagar = () => {


        setTitulo('Confirmação')
        setFrase('Confirma apagar?')
        setAcao('apagar')
        setOpen(true)

    }


    const { mutate: apagaMutate } = useMutation({

        mutationKey: ['apagaEmissao', emissao_id],
        mutationFn: async () => {

            setOpen(false)

            const result = await api.delete(`emissao/${cliente_id}/${emissao_id}`)
            //console.log(result.data)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status == 'ok') {


                toast.success('Registro apagado com sucesso!')
                props.setShow(false)
                props.carregaEmissoes()
                
                //setEmissao_id(undefined)
                props.setEmissao_id(undefined)
                props.setPin(undefined)
                
                //setPrimeiroEndosso(false)
                
                

            }



        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })


    const validaSalvar = () => {

        if (tomadores.length == 0) {

            toast.error('Informe o tomador!')
            return false

        }

        if (favorecidos.length == 0) {

            toast.error('Informe o favorecido!')
            return false
        }


        setTitulo('Confirmação')
        setFrase('Confirma salvar?')
        setAcao('salvar')
        setOpen(true)

    };


    const salva = () => {

        setOpen(false)

        //console.log(emissao_id, endosso)

        if (emissao_id && endosso == false) {

            var dataPostPut = {

                cliente_id: cliente_id,
                dataEmissao: moment(startDate).format('YYYY-MM-DD'),
                dataInicio: moment(startDate2).format('YYYY-MM-DD'),
                dataVencimento: moment(dataVencimento).format('YYYY-MM-DD'),
                dias: dias,
                dataVencimentoIndeterminado: dataVencimentoIndeterminado == '1' ? true : dataVencimentoIndeterminado == '0' ? false : null,
                moeda_id: moeda_id,
                //valor: valor ? Number(valor.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valor,
                objeto: objeto,
                modalidade_id: modalidade_id,
                modalidadeTexto: modalidadeTexto,
                taxa: taxa,
                //premio: premio ? Number(premio.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                premio,
                pago: pago == '1' ? true : pago == '0' ? false : null,
                //valorPago: valorPago ? Number(valorPago.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorPago,

                multa: multa == '1' ? true : multa == '0' ? false : null,
                trabalhista: trabalhista == '1' ? true : trabalhista == '0' ? false : null,
                fiscal: fiscal == '1' ? true : fiscal == '0' ? false : null,
                textoMulta: textoMulta,
                textoTrabalhista: textoTrabalhista,
                textoFiscal: textoFiscal,

                ad_usr: usuario_id_session,
                observacoesCorretor: observacoesCorretor,
                observacoesSubscritor: observacoesSubscritor,
                //valorComissao: valorComissao ? Number(valorComissao.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorComissao,
                percentualComissao: percentualComissao,
                //valorSpread: valorSpread ? Number(valorSpread.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorSpread,
                favorecidos: favorecidos.map((rs: iFavorecido) => rs.favorecido_id),
                tomadores: tomadores.map((rs: iTomador) => rs.tomador_id),

                //endosso: endosso ? endosso : null,
                //endosso_emissao_id: endosso_emissao_id ? endosso_emissao_id : null

            }

            console.log(dataPostPut)

            api.put(`emissao/${props.emissao_id}`, dataPostPut).then((result) => {

                if (result.data.status == 'ok') {

                    toast.success('Registro salvo com sucesso!')

                    props.carregaEmissoes()

                }

            }).catch((err) => {
                console.log(err.response)
            })

        } else {

            var dataPost = {

                cliente_id: cliente_id,
                dataEmissao: moment(startDate).format('YYYY-MM-DD'),
                dataInicio: moment(startDate2).format('YYYY-MM-DD'),
                dataVencimento: moment(dataVencimento).format('YYYY-MM-DD'),
                dias: dias,
                dataVencimentoIndeterminado: dataVencimentoIndeterminado == '1' ? true : dataVencimentoIndeterminado == '0' ? false : null,
                moeda_id: moeda_id,
                //valor: valor ? Number(valor.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valor,
                objeto: objeto,
                modalidade_id: modalidade_id,
                modalidadeTexto: modalidadeTexto,
                taxa: taxa,
                //premio: premio ? Number(premio.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                premio,
                pago: pago == '1' ? true : pago == '0' ? false : null,
                //valorPago: valorPago ? Number(valorPago.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorPago,

                multa: multa == '1' ? true : multa == '0' ? false : null,
                trabalhista: trabalhista == '1' ? true : trabalhista == '0' ? false : null,
                fiscal: fiscal == '1' ? true : fiscal == '0' ? false : null,
                textoMulta: textoMulta,
                textoTrabalhista: textoTrabalhista,
                textoFiscal: textoFiscal,

                ad_usr: usuario_id_session,
                observacoesCorretor: observacoesCorretor,
                observacoesSubscritor: observacoesSubscritor,
                //valorComissao: valorComissao ? Number(valorComissao.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorComissao,
                percentualComissao: percentualComissao,
                //valorSpread: valorSpread ? Number(valorSpread.toString().replaceAll('.', '').replaceAll(',', '.')) : null,
                valorSpread,
                favorecidos: favorecidos.map((rs: iFavorecido) => rs.favorecido_id),
                tomadores: tomadores.map((rs: iTomador) => rs.tomador_id),

                endosso: endosso ? endosso : null,
                endosso_emissao_id: endosso_emissao_id ? endosso_emissao_id : null

            }

            //console.log(dataPost)
            //return false


            api.post('emissao', dataPost).then((result) => {

                //console.log(result.data)

                if (result.data.status == 'ok') {

                    setEmissao_id(result.data.emissao_id)
                    props.setEmissao_id(result.data.emissao_id)

                    props.setPin(result.data.pin)
                    //setPrimeiroEndosso(false)
                    toast.success('Salvo com sucesso!')
                    props.carregaEmissoes()
                    
                    setEndosso(false)

                    if (!endosso) {


                        setOpen(false)
                        setAcao('')
                        //props.setShow(false)


                    } else {


                        carregaEmissao(result.data.emissao_id)
                        setEndosso(false)
                        //setCarregadoDaApi(false)
                        setKey('dadosGerais')                        
                        setAcao('novoEndosso')
                        setTitulo('Emissão')
                        setFrase('Endosso gerado com sucesso!')
                        setOpen(true)




                    }



                }


            }).catch((err) => {
                console.log(err.response)
                toast.error('Erro ao salvar!')
            })


        }

    }

    const carregaTextoModalidade = () => {

        var dataPost = {
            cliente_id: cliente_id,
        }

        api.post(`modalidadeListaUm/${modalidade_id}`, dataPost).then((result) => {

            setModalidadeTexto(result.data[0].texto)
            setObjeto(result.data[0].objeto)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const { mutate: gravaCcg } = useMutation({

        mutationKey: ['gravaCcg', emissao_id],
        mutationFn: async () => {

            var dataPost = {

                cliente_id,

            }

            const result = await api.put(`gravaCcg/${emissao_id}`, dataPost)
            //console.log(result.data)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                const url = data.link;

                //console.log('result.data.pdfUrl', url);

                setLinkCCg(url);
                setCCg(true);
                toast.success('Contra garantia gravada com sucesso!');

                setOpen(true)
                setTitulo('Contra Garantia')
                setFrase('Deseja fazer o download do documento?')
                setAcao('contraGarantia')

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }


    })

    const apagaCg = () => {

        const dataPost = { cliente_id, pin }

        api.delete(`apagaCcg/${emissao_id}`, { data: dataPost }).then((result) => {
            if (result.data.status == 'ok') {
                toast.success('Certificado Contra Garantia removido com sucesso!')
                setCCg(false)
            }
        }).catch((err) => {
            console.log(err.response)
        })

    }


    const { mutate: gravaNp } = useMutation({

        mutationKey: ['gravaNp', emissao_id],
        mutationFn: async () => {

            var dataPost = {

                cliente_id,

            }

            const result = await api.put(`gravaNp/${emissao_id}`, dataPost)
            //console.log(result.data)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                const url = data.link;

                //console.log('result.data.pdfUrl', url);

                setLinkNp(url);
                setNp(true);
                toast.success('Nota Promissória gravada com sucesso!');

                setOpen(true)
                setTitulo('Nota Promissória')
                setFrase('Deseja fazer o download do documento?')
                setAcao('notaPromissoria')

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }


    })

    useEffect(() => {
        if (isMutating > 0 && !savingToastId.current) {
            savingToastId.current = toast.loading("Aguarde...");
        }

        if (isMutating === 0 && savingToastId.current) {
            toast.dismiss(savingToastId.current);
            savingToastId.current = null;
            
        }
    }, [isMutating]);


    const { mutate: gravaFianca } = useMutation({

        mutationKey: ['gravaFianca', emissao_id],
        mutationFn: async () => {

            const dataPost = {
                cliente_id,
            }

            const result = await api.put(`gravaGarantia/${emissao_id}`, dataPost)
            return result.data ?? {}


        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                const url = data.link;

                //console.log('result.data.pdfUrl', url);

                setLinkGarantia(url);
                setGarantia(true);
                toast.success('Fiança gravada com sucesso!');


                setOpen(true)
                setTitulo('Fiança')
                setFrase('Deseja fazer o download do documento?')
                setAcao('fianca')

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }



    })


    const apagaFianca = () => {

        const dataPost = { cliente_id, pin }

        api.delete(`apagaGarantia/${emissao_id}`, { data: dataPost }).then((result) => {
            if (result.data.status == 'ok') {

                toast.success('Fiança removida com sucesso!')
                setGarantia(false)
            }
        }).catch((err) => {
            console.log(err.response)
        })

    }


    const { mutate: gravaMinuta } = useMutation({

        mutationKey: ['gravaMinuta', emissao_id],
        mutationFn: async () => {

            const dataPost = { cliente_id };

            const result = await api.put(`gravaMinuta/${emissao_id}`, dataPost)
            return result.data ?? {}


        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                const url = data.link;

                setLinkMinuta(url);
                setMinuta(true);
                toast.success('Minuta gravada com sucesso!');

                //console.log('result.data.pdfUrl:', url);
                //console.log('linkMinuta:', url);


                setOpen(true)
                setTitulo('Minuta')
                setFrase('Deseja fazer o download do documento?')
                setAcao('minuta')
            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })




    const apagaMinuta = () => {

        const dataPost = { cliente_id, pin }

        api.delete(`apagaMinuta/${emissao_id}`, { data: dataPost }).then((result) => {
            if (result.data.status == 'ok') {
                toast.success('Minuta removida com sucesso!')
                setMinuta(false)
            }
        }).catch((err) => {
            console.log(err.response)
        })

    }


    const { mutate: gravaProposta } = useMutation({

        mutationKey: ['gravaProposta', emissao_id],
        mutationFn: async () => {

            const dataPost = { cliente_id };
            const result = await api.put(`gravaProposta/${emissao_id}`, dataPost)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                const url = data.link;

                setLinkProposta(url);
                setProposta(true);
                toast.success('Proposta gravada com sucesso!');

                //console.log('result.data.pdfUrl:', url);
                //console.log('linkProposta:', url);


                setOpen(true)
                setTitulo('Proposta')
                setFrase('Deseja fazer o download do documento?')
                setAcao('proposta')


            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })


    const apagaProposta = () => {

        const dataPost = { cliente_id, pin }

        api.delete(`apagaProposta/${emissao_id}`, { data: dataPost }).then((result) => {
            if (result.data.status === 'ok') {
                toast.success('Proposta removida com sucesso!')
                setProposta(false)
            }
        }).catch((err) => {
            console.log(err.response)
        })

    }


    const apagaNp = () => {

        const dataPost = { cliente_id, pin }

        api.delete(`apagaNp/${emissao_id}`, { data: dataPost }).then((result) => {
            if (result.data.status === 'ok') {
                toast.success('Nota Promissória removida com sucesso!')
                setNp(false)
            }
        }).catch((err) => {
            console.log(err.response)
        })

    }



    useEffect(() => {

        if (emissao_id) {
            carregaEmissao(emissao_id)
        }

    }, [emissao_id])

    return (

        <div>


            <div className="row g-3">

                <div className="col-md-12">

                    <select className="form-control" value={cliente_id} disabled={clientes.length > 1 && props.emissao_id == null ? false : true} onChange={event => setCliente_id(Number(event.target.value))} >
                        {clientes.length > 1 && (<option value="">[Selecione]</option>)}

                        {

                            clientes.map((rs: iClientes) =>

                                <option value={rs.cliente_id}>{rs.cnpj} - {rs.razaoSocial}</option>
                            )

                        }

                    </select>
                </div>
                <div className="col-md-12">

                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key ?? "dadosGerais"}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >

                        <Tab eventKey="dadosGerais" title={
                            <>
                                <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                    <i
                                        className="material-icons-outlined">group</i>
                                    Tomador
                                    <Badge style={{ fontSize: '0.7rem' }} bg='secondary'>{totalTomadores}</Badge>

                                </div>
                            </>
                        }>



                            <form className="row g-3">

                                <div className="col-md-12">

                                    <input type="text"
                                        className="form-control"
                                        style={{ backgroundColor: colorTomador }}
                                        value={tomador}
                                        onChange={event => setTomador(event.target.value)} onFocus={() => { setTomador(''); setResultadoTomador(''); setTomador_id(undefined) }}
                                        placeholder="Busque o tomador para vinculação"
                                    />
                                    {resultadoTomador}
                                </div>
                                <div className="col-md-12">
                                    <fieldset className="form-group">


                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>



                                                    </th>

                                                    <th style={{ fontSize: '11px', backgroundColor: '#EFEFEF', textAlign: 'right' }}>

                                                        &nbsp;

                                                    </th>

                                                </tr>

                                            </thead>
                                            <tbody>

                                                {tomadoresTabela}

                                            </tbody>

                                        </table>



                                    </fieldset>
                                </div>



                            </form>



                        </Tab>
                        <Tab eventKey="dadosFavorecido" title={
                            <>
                                <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                    <i
                                        className="material-icons-outlined">group</i>
                                    Favorecido
                                    <Badge style={{ fontSize: '0.7rem' }} bg='primary'>{totalFavorecidos}</Badge>

                                </div>
                            </>
                        }>



                            <form className="row g-3">

                                <div className="col-md-12">
                                    <label className="form-label">Favorecido</label>
                                    <input type="text" className="form-control" style={{ backgroundColor: colorFavorecido }} value={favorecido} onChange={event => setFavorecido(event.target.value)} onFocus={() => { setFavorecido(''); setFavorecido_id(undefined) }} />
                                    {resultadoFavorecido}
                                </div>

                                <div className="col-md-12">
                                    <fieldset className="form-group">


                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>



                                                    </th>

                                                    <th style={{ fontSize: '11px', backgroundColor: '#EFEFEF', textAlign: 'right' }}>

                                                        &nbsp;

                                                    </th>

                                                </tr>

                                            </thead>
                                            <tbody>

                                                {favorecidosTabela}

                                            </tbody>

                                        </table>



                                    </fieldset>
                                </div>



                            </form>



                        </Tab>


                        <Tab eventKey="informacoes" title={
                            <>
                                <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                    <i
                                        className="material-icons-outlined">info</i>
                                    Informações

                                </div>
                            </>
                        }>

                            <form className="row g-3">

                                <div className="col-md-2">
                                    <label className="form-label">Data emissão</label>
                                    <DatePicker
                                        className="form-control"
                                        locale={ptBR}

                                        wrapperClassName="w-100"
                                        dateFormat="dd/MM/yyyy"
                                        selected={startDate}
                                        onChange={selectDateHandler}
                                        //minDate={today}
                                        customInput={

                                            <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />

                                        }
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label">Início da vigência</label>
                                    <DatePicker
                                        className="form-control"
                                        locale={ptBR}

                                        wrapperClassName="w-100"
                                        dateFormat="dd/MM/yyyy"
                                        selected={startDate2}
                                        onChange={selectDateHandler2}
                                        //minDate={today}
                                        onBlur={calculaDataVigencia}
                                        customInput={

                                            <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />

                                        }
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Vencimento indeterminado?</label>
                                    <select className="form-control"

                                        value={dataVencimentoIndeterminado}
                                        onChange={event => setDataVencimentoIndeterminado(event.target.value)}

                                    >

                                        <option value="">[Selecione]</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>

                                    </select>
                                </div>

                                <div className="col-md-2" style={{ display: dataVencimentoIndeterminado == '1' ? 'none' : 'table-row' }}>
                                    <label className="form-label">Dias</label>
                                    <input type="text" className="form-control"
                                        value={dias}
                                        onChange={event => setDias(event.target.value ? Number(event.target.value) : undefined)}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        maxLength={4}
                                        onBlur={calculaDataVigencia}
                                    />
                                </div>

                                <div className="col-md-2" style={{ display: dataVencimentoIndeterminado == '1' ? 'none' : 'table-row' }}>
                                    <label className="form-label">Final da vigência</label>
                                    <DatePicker
                                        className="form-control"
                                        locale={ptBR}

                                        wrapperClassName="w-100"
                                        dateFormat="dd/MM/yyyy"
                                        selected={dataVencimento}
                                        onChange={selectDateHandlerVencimento}
                                        //minDate={today}
                                        onBlur={calculaDiasDeVigencia}
                                        customInput={

                                            <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />

                                        }
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Moeda</label>
                                    <select className="form-control"
                                        value={moeda_id}
                                        onChange={event => setMoeda_id(event.target.value ? Number(event.target.value) : undefined)}

                                    >
                                        <option value="">[Selecione]</option>
                                        {moedas.map((rs: iMoedas) => <option value={rs.moeda_id}>{rs.descricao}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Valor segurado</label>

                                    <CurrencyInputBR
                                        value={valor}
                                        onChange={(val) => setValor(val)}
                                        className="form-control"
                                        placeholder="Digite um valor"
                                    />
                                    </div>
                                <div className="col-md-3">
                                    <label className="form-label">Endosso?</label>
                                    <TextInput className="form-control" value={endossoDescricao} disabled />
                                </div>


                                <div className="col-md-12">
                                    <label className="form-label">Modalidade</label>
                                    <select className="form-control" value={modalidade_id} onChange={event => {setModalidade_id(event.target.value ? Number(event.target.value) : undefined)}}>
                                        <option value="">[Selecione]</option>
                                        {modalidades}
                                    </select>
                                </div>


                                <div className="col-md-12" >
                                    <label className="form-label">Objeto</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={objeto}
                                        onChange={(value) => setObjeto(value)}
                                    />
                                </div>





                                <div className="col-md-12">
                                    <label className="form-label">Texto modalidade</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={modalidadeTexto}
                                        onChange={(value) => setModalidadeTexto(value)}
                                    />
                                </div>


                                <div className="col-md-12">
                                    <label className="form-label">Multas</label>
                                    <select className="form-control" value={multa} onChange={event => setMulta(event.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                                <div className="col-md-12" style={{ display: multa == '1' ? 'table-row' : 'none' }}>
                                    <label className="form-label">Texto multa</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={textoMulta}
                                        onChange={(value) => setTextoMulta(value)}
                                    />
                                </div>

                                <div className="col-md-12">
                                    <label className="form-label">Trabalhista e previdenciário</label>
                                    <select className="form-control" value={trabalhista} onChange={event => setTrabalhista(event?.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                                <div className="col-md-12" style={{ display: trabalhista == '1' ? 'table-row' : 'none' }}>
                                    <label className="form-label">Texto trabalhista</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={textoTrabalhista}
                                        onChange={(value) => setTextoTrabalhista(value)}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label className="form-label">Fiscal e tributário</label>
                                    <select className="form-control" value={fiscal} onChange={event => setFiscal(event.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                                <div className="col-md-12" style={{ display: fiscal == '1' ? 'table-row' : 'none' }}>
                                    <label className="form-label">Texto fiscal e tributário</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={textoFiscal}
                                        onChange={(value) => setTextoFiscal(value)}
                                    />
                                </div>


                            </form>

                        </Tab>
                        <Tab eventKey="premio" title={
                            <>
                                <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                    <i
                                        className="material-icons-outlined">emoji_events</i>
                                    Prêmio e Comissão

                                </div>
                            </>
                        }>

                            <form className="row g-3">

                                <div className="col-md-3">
                                    <label className="form-label">Valor do prêmio</label>
                                   
                                    <CurrencyInputBR
                                        value={premio}
                                        onChange={(val) => setPremio(val)}
                                        className="form-control"
                                        placeholder="Digite um valor"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Taxa aplicada (%)</label>
                                    <input type="number" className="form-control" value={taxa} onChange={event => setTaxa(event.target.value ? Number(event.target.value) : undefined)} />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">Valor da comissão</label>
                                   
                                    <CurrencyInputBR
                                        value={valorComissao}
                                        onChange={(val) => setValorComissao(val)}
                                        className="form-control"
                                        placeholder="Digite um valor"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">% de comissão</label>
                                    <input type="number" className="form-control" value={percentualComissao} onChange={event => setPercentualComissao(event.target.value ? Number(event.target.value) : undefined)} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Valor do spread</label>
                                   

                                    <CurrencyInputBR
                                        value={valorSpread}
                                        onChange={(val) => setValorSpread(val)}
                                        className="form-control"
                                        placeholder="Digite um valor"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Pago</label>
                                    <select className="form-control" value={pago} onChange={event => setPago(event.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                                <div className="col-md-3" style={{ display: pago == '1' ? 'table-row' : 'none' }}>
                                    <label className="form-label">Valor pago</label>
                                   
                                    <CurrencyInputBR
                                        value={valorPago}
                                        onChange={(val) => setValorPago(val)}
                                        className="form-control"
                                        placeholder="Digite um valor"
                                    />
                                </div>


                            </form>

                        </Tab>
                        <Tab eventKey="historico" title={
                            <>
                                <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                    <i
                                        className="material-icons-outlined">schedule</i>
                                    Histórico

                                </div>
                            </>
                        }>

                            <form className="row g-3">

                                <div className="col-md-12">
                                    <label className="form-label">Observações do corretor</label>
                                    <JoditEditorComponent
                                        key="editor-corretor"
                                        initialValue={observacoesCorretor}
                                        onChange={(value) => setObservacoesCorretor(value)}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label className="form-label">Observações do subscritor</label>
                                    <JoditEditorComponent
                                        key="editor-subscritor"
                                        initialValue={observacoesSubscritor}
                                        onChange={(value) => setObservacoesSubscritor(value)}
                                    />
                                </div>


                            </form>

                        </Tab>

                        {

                            emissao_id && (

                                <Tab eventKey="anexos" title={
                                    <>
                                        <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                            <i className="material-icons-outlined">insert_drive_file</i>
                                            Anexos
                                            <Badge style={{ fontSize: '0.7rem' }} bg='warning'>{totalAnexos}</Badge>
                                        </div>
                                    </>
                                }>

                                    <div className="row g-3">


                                        <EmissaoAnexos emissao_id={emissao_id} setTotalAnexos={setTotalAnexos} cliente_id={props.cliente_id} usuario_id={usuario_id_session} />

                                    </div>

                                </Tab>

                            )
                        }

                        {
                            emissao_id && (

                                <Tab eventKey="pdf" title={
                                    <>
                                        <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                            <i
                                                className="material-icons-outlined">print</i>
                                            PDF

                                        </div>
                                    </>
                                }>

                                    <form className="row g-3">

                                        <div className="col-md-12">

                                            <div className="btn-group">
                                                <button type="button" className="btn btn-primary btn-sm" style={{ cursor: 'auto' }}>Fiança</button>
                                                <button
                                                    type="button"

                                                    className="btn btn-primary btn-sm split-bg-primary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                                    <a className="dropdown-item" style={{ display: garantia == true ? 'block' : 'none', cursor: 'pointer' }} href={linkGarantia} target="_blank">Download</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => gravaFianca()}>{garantia == false ? 'Gerar' : 'Gerar novamente'}</a>
                                                    <a className="dropdown-item" style={{ display: garantia == true ? 'block' : 'none', cursor: 'pointer' }} onClick={() => apagaFianca()}>Apagar</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setUploadTipo('G'); setShowUpload(true); }}>Upload</a>
                                                </div>
                                            </div>

                                            <div className="btn-group" style={{ marginLeft: 5 }}>
                                                <button type="button" className="btn btn-success btn-sm" style={{ cursor: 'auto' }}>Minuta</button>
                                                <button
                                                    type="button"

                                                    className="btn btn-success btn-sm split-bg-primary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                                    <a className="dropdown-item" style={{ display: minuta == true ? 'block' : 'none', cursor: 'pointer' }} href={linkMinuta} target="_blank">Download</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => gravaMinuta()}>{minuta == false ? 'Gerar' : 'Gerar novamente'}</a>
                                                    <a className="dropdown-item" style={{ display: minuta == true ? 'block' : 'none', cursor: 'pointer' }} onClick={() => apagaMinuta()}>Apagar</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setUploadTipo('M'); setShowUpload(true); }}>Upload</a>
                                                </div>
                                            </div>

                                            <div className="btn-group" style={{ marginLeft: 5 }}>
                                                <button type="button" className="btn btn-secondary btn-sm" style={{ cursor: 'auto' }}>Proposta</button>
                                                <button
                                                    type="button"

                                                    className="btn btn-secondary btn-sm split-bg-primary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                                    <a className="dropdown-item" style={{ display: proposta == true ? 'block' : 'none', cursor: 'pointer' }} href={linkProposta} target="_blank">Download</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => gravaProposta()}>{proposta == false ? 'Gerar' : 'Gerar novamente'}</a>
                                                    <a className="dropdown-item" style={{ display: proposta == true ? 'block' : 'none', cursor: 'pointer' }} onClick={() => apagaProposta()}>Apagar</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setUploadTipo('P'); setShowUpload(true); }}>Upload</a>
                                                </div>
                                            </div>

                                            <div className="btn-group" style={{ marginLeft: 5 }}>
                                                <button type="button" className="btn btn-info btn-sm" style={{ cursor: 'auto' }}>Nota Promissória</button>
                                                <button
                                                    type="button"

                                                    className="btn btn-info btn-sm split-bg-primary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                                    <a className="dropdown-item" style={{ display: np == true ? 'block' : 'none', cursor: 'pointer' }} href={linkNp} target="_blank">Download</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => gravaNp()}>{np == false ? 'Gerar' : 'Gerar novamente'}</a>
                                                    <a className="dropdown-item" style={{ display: np == true ? 'block' : 'none', cursor: 'pointer' }} onClick={() => apagaNp()}>Apagar</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setUploadTipo('NP'); setShowUpload(true); }}>Upload</a>
                                                </div>
                                            </div>

                                            <div className="btn-group" style={{ marginLeft: 5 }}>
                                                <button type="button" className="btn btn-warning btn-sm" style={{ cursor: 'auto' }}>Certificado Contra Garantia</button>
                                                <button
                                                    type="button"

                                                    className="btn btn-warning btn-sm split-bg-primary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                                    <a className="dropdown-item" style={{ display: ccg == true ? 'block' : 'none', cursor: 'pointer' }} href={linkCCg} target="_blank">Download</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => gravaCcg()}>{ccg == false ? 'Gerar' : 'Gerar novamente'}</a>
                                                    <a className="dropdown-item" style={{ display: ccg == true ? 'block' : 'none', cursor: 'pointer' }} onClick={() => apagaCg()}>Apagar</a>
                                                    <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setUploadTipo('CCG'); setShowUpload(true); }}>Upload</a>
                                                </div>
                                            </div>


                                        </div>

                                        <EmissaoDocumentoUpload
                                            show={showUpload}
                                            onClose={() => setShowUpload(false)}
                                            tipo={uploadTipo}
                                            tituloDoc={{
                                                G: 'Fiança',
                                                M: 'Minuta',
                                                P: 'Proposta',
                                                NP: 'Nota Promissória',
                                                CCG: 'Certificado Contra Garantia',
                                            }[uploadTipo]}
                                            emissao_id={emissao_id}
                                            cliente_id={cliente_id}
                                            onSuccess={(data) => {

                                                if (uploadTipo === 'G') {
                                                    setLinkGarantia(data.link);
                                                    setGarantia(true);
                                                    setOpen(true); setTitulo('Fiança'); setFrase('Deseja fazer o download do documento?'); setAcao('fianca');
                                                } else if (uploadTipo === 'M') {
                                                    setLinkMinuta(data.link);
                                                    setMinuta(true);
                                                    setOpen(true); setTitulo('Minuta'); setFrase('Deseja fazer o download do documento?'); setAcao('minuta');
                                                } else if (uploadTipo === 'P') {
                                                    setLinkProposta(data.link);
                                                    setProposta(true);
                                                    setOpen(true); setTitulo('Proposta'); setFrase('Deseja fazer o download do documento?'); setAcao('proposta');
                                                } else if (uploadTipo === 'NP') {
                                                    setLinkNp(data.link);
                                                    setNp(true);
                                                    setOpen(true); setTitulo('Nota Promissória'); setFrase('Deseja fazer o download do documento?'); setAcao('notaPromissoria');
                                                } else if (uploadTipo === 'CCG') {
                                                    setLinkCCg(data.link);
                                                    setCCg(true);
                                                    setOpen(true); setTitulo('Contra Garantia'); setFrase('Deseja fazer o download do documento?'); setAcao('contraGarantia');
                                                }

                                            }}
                                        />

                                    </form>

                                </Tab>

                            )
                        }

                    </Tabs>

                </div>

                <div className="col-md-12" style={{ marginTop: 50, textAlign: 'right' }}>


                    <button type="button" className="btn btn-secondary" onClick={() => props.setShow(false)} style={{ marginLeft: 5 }}>Fechar</button>
                    {

                        !endossado && emissao_id && (


                            <button type="button" className="btn btn-info" style={{ marginLeft: 5, }} onClick={() => geraEndosso()}>Gerar endosso</button>

                        )

                    }

                    {

                        emissao_id && (

                            <button type="button" className="btn btn-danger" style={{ marginLeft: 5, }} onClick={validaApagar}>Apagar</button>

                        )

                    }


                    <button type="button" className="btn btn-success" style={{ marginLeft: 5, }} onClick={validaSalvar}>Salvar</button>

                </div>
            </div>



            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth>

                <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column" }}>

                    <div style={{ textAlign: 'justify' }}>
                        {frase}
                    </div>

                </DialogContent>
                <DialogActions>

                    {

                        acao != 'novoEndosso' && (

                            <Button color="error" variant="contained" onClick={() => setOpen(false)} >
                                Cancelar
                            </Button>

                        )

                    }

                    

                    {

                        acao == 'notaPromissoria' && (


                            <Button color="success" variant="contained" onClick={() => { window.open(linkNp); setOpen(false) }}>
                                Ok
                            </Button>


                        )

                    }

                    {

                        acao == 'fianca' && (


                            <Button color="success" variant="contained" onClick={() => { window.open(linkGarantia); setOpen(false) }}>
                                Ok
                            </Button>


                        )

                    }


                    {

                        acao == 'minuta' && (


                            <Button color="success" variant="contained" onClick={() => { window.open(linkMinuta); setOpen(false) }}>
                                Ok
                            </Button>


                        )

                    }

                    {

                        acao == 'proposta' && (


                            <Button color="success" variant="contained" onClick={() => { window.open(linkProposta); setOpen(false) }}>
                                Ok
                            </Button>


                        )

                    }


                    {

                        acao == 'contraGarantia' && (


                            <Button color="success" variant="contained" onClick={() => { window.open(linkCCg); setOpen(false) }}>
                                Ok
                            </Button>


                        )

                    }

                    {
                        acao == 'novoEndosso' && (


                            <Button color="success" variant="contained" onClick={() => { setOpen(false) }}>
                                Ok
                            </Button>

                        )
                    }


                    {

                        acao == 'salvar' && (


                            <Button color="success" variant="contained" onClick={() => {
                                salva();
                                props.carregaEmissoes();
                            }}>
                                Ok
                            </Button>

                        )

                    }


                    {

                    acao == 'apagar' && (


                        <Button color="success" variant="contained" onClick={() => {
                            apagaMutate();
                            props.carregaEmissoes();
                        }}>
                            Ok
                        </Button>

                    )

                    }




                </DialogActions>
            </Dialog>




        </div>

    )
}

export default FormEmissao